import { useState } from "react";
import { EXTERNAL_LINKS, INTERNAL_PATHS } from "routes/paths";
import "./index.scss";

export const OrderTermsAndConditions = ({ termsAndConditions, brand }) => {
  const [termsOpen, setTermsOpen] = useState(false);

  const toggleTermsOpening = () => {
    setTermsOpen((currentValue) => !currentValue);
  };

  if (!termsAndConditions) return null;

  return (
    <div
      className="order-terms-and-conditions"
      data-testid="order-terms-and-conditions"
    >
      <button onClick={toggleTermsOpening} className="terms-toggle">
        {termsOpen ? "-" : "+"} terms &amp; conditions
      </button>
      {termsOpen && (
        <div className="terms-opened-area" data-testid="terms-area">
          <p>
            <b>GCX</b>
          </p>
          <p className="highlight">
            For questions about redeeming gift cards, please visit our{" "}
            <a
              href={EXTERNAL_LINKS.MARKETPLACE_ZENDESK}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Help Center"
            >
              Help Center
            </a>
            .
          </p>
          <p>
            All trademarks not owned by GCX that appear on this site are the
            property of their respective owners. GCX is not the issuer of any of
            the gift cards or other closed-loop products on GCX and is not
            related to any merchant whose trademark and gift cards appear on GCX
            for sale. All gift cards sold on our marketplace are backed by our
            90 Day Money-Back Guarantee.{" "}
            <a
              href={INTERNAL_PATHS.TERMS_OF_USE}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="View full GCX Terms of Use."
            >
              View full GCX Terms of Use.
            </a>
          </p>
          <p>
            <b>{brand}</b>
          </p>
          <p>{termsAndConditions}</p>
        </div>
      )}
    </div>
  );
};
